<div class="modal-header">
    @if(isLoading || !containerJobDetails ){
    <h4 class="modal-title">Container Job Details</h4>
    }@else{
    <h4 class="modal-title">Container No. {{ getContainerNumber() }}</h4>
    }
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" [destroyOnHide]="true" class="nav-tabs">
        <li [ngbNavItem]="1">
            <button ngbNavLink>Details</button>
            <ng-template ngbNavContent>
                @if(isLoading || !containerJobDetails || !currentLegData){
                <h4>
                    Loading...
                </h4>
                }@else{
                <div class="eye-view-grid-wrapper mt-1">
                    <app-container-job-details [currentLegData]="currentLegData" [isInboundJob]="isInboundJob"
                        [isIntermodalJob]="isIntermodalJob"></app-container-job-details>
                    <div>
                        <app-container-job-from-location-details [currentLegData]="currentLegData"
                            [fromJobContact]="currentLegData.fromJobContact"></app-container-job-from-location-details>
                        <app-container-job-delivery-location-details [currentLegData]="currentLegData"
                            [toJobContact]="currentLegData.toJobContact"></app-container-job-delivery-location-details>

                        @if (firstLeg || lastLeg) {
                        <app-container-job-dehire-point-details [currentLegData]="currentLegData"
                            [isInboundJob]="isInboundJob" [firstContainerLeg]="firstLeg"
                            [lastContainerLeg]="lastLeg"></app-container-job-dehire-point-details>
                        }
                    </div>
                </div>
                <div class="mt-3">
                    <app-container-job-leg-details
                        [containerLegsData]="containerLegsData"></app-container-job-leg-details>
                </div>
                }
            </ng-template>
        </li>
        <li [ngbNavItem]="2">
            <button ngbNavLink>Attachments</button>
            <ng-template ngbNavContent>
                <div class="mt-1">
                    @if (currentLegData)
                    {
                    <app-container-job-attachment-details [containerJobItemId]="containerJobItemId"
                        [containerJobId]="currentLegData.containerJobId"></app-container-job-attachment-details>
                    }
                </div>
            </ng-template>
        </li>
    </ul>

    <div [ngbNavOutlet]="nav"></div>

</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close('Close click')">Close</button>
</div>